/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Measurement source
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type MeasurementSourceEnum = 'Rough Guess' | 'Expert Knowledge' | 'Rapid Assessment' | 'Intensive Assessment' | 'Sampling Based';

export const MeasurementSourceEnum = {
    RoughGuess: 'Rough Guess' as MeasurementSourceEnum,
    ExpertKnowledge: 'Expert Knowledge' as MeasurementSourceEnum,
    RapidAssessment: 'Rapid Assessment' as MeasurementSourceEnum,
    IntensiveAssessment: 'Intensive Assessment' as MeasurementSourceEnum,
    SamplingBased: 'Sampling Based' as MeasurementSourceEnum
};

marker('Rough Guess');
marker('Expert Knowledge');
marker('Rapid Assessment');
marker('Intensive Assessment');
marker('Sampling Based');

